import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { SiteHeader } from '../../components/SiteHeader';
import { FooterSection } from '../../components/FooterSection';
import './RefundPolicyPage.css';

export function RefundPolicyPage() {
  useDocumentTitle('Refund Policy');

  return (
    <div className="landing refund-page">
      <SiteHeader />

      <main className="refund-page__main">
        <div className="container refund-page__content">
          <h1>Refund Policy</h1>
          <p className="refund-page__updated">Last Updated: August 1st, 2026</p>

          <h2>1. Overview</h2>
          <p>
            This Refund Policy applies to all services, subscriptions, software
            access, automation systems, and related products provided by David
            Osmukhin, operating as a sole proprietor under the business name
            Review Lumen (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot;
            or &quot;our&quot;).
          </p>
          <p>
            Nothing in this Refund Policy limits or excludes any mandatory
            consumer rights that cannot be waived under applicable law.
          </p>
          <p>
            By purchasing or subscribing to our Services, you agree to this
            Refund Policy.
          </p>

          <h2>2. Free Trials</h2>
          <p>Where a free trial is offered:</p>
          <ul>
            <li>
              You may cancel your subscription at any time during the trial
              period.
            </li>
            <li>If cancelled before the trial ends, you will not be charged.</li>
            <li>
              Once the trial period expires, your selected subscription plan may
              automatically begin unless cancelled beforehand.
            </li>
          </ul>
          <p>
            It is your responsibility to cancel the trial before the billing date
            if you do not wish to continue.
          </p>

          <h2>3. Subscription Payments</h2>
          <p>
            Subscriptions may renew automatically according to the billing cycle
            selected during checkout unless cancelled before renewal.
          </p>
          <p>
            By subscribing, you authorise recurring payments through our payment
            providers, including but not limited to:
          </p>
          <ul>
            <li>Paddle</li>
            <li>Stripe</li>
            <li>Other approved payment processors</li>
          </ul>

          <h2>4. 14-Day Refund</h2>
          <p>
            Customers may request a full refund within 14 calendar days of the
            original purchase date.
          </p>
          <p>
            If you are not satisfied with your purchase for any reason, you may
            request a full refund within 14 calendar days of the original
            purchase date by contacting us at{' '}
            <a href="mailto:support@reviewlumen.com">support@reviewlumen.com</a>
            .
          </p>
          <p>
            Refund requests received within the 14-day period will be honoured
            and refunded to the original payment method.
          </p>
          <p>
            Refunds requested after the 14-day refund period are generally not
            available unless otherwise required by applicable law or approved at
            our sole discretion.
          </p>
          <p>
            If a refund is issued, access to the refunded Services,
            subscriptions, software, and related features may be suspended or
            terminated.
          </p>

          <h2>5. Refund Processing Time</h2>
          <p>
            Approved refunds will be processed within 7 business days of
            approval.
          </p>
          <p>
            Refunds will be issued to the original payment method used for the
            purchase, where possible.
          </p>
          <p>
            Please note that your bank, card issuer, or payment provider may
            require additional time to complete the transaction and for the
            refunded amount to appear in your account.
          </p>

          <h2>6. Cancellations</h2>
          <ul>
            <li>You may cancel your subscription at any time.</li>
            <li>
              Cancellation prevents future billing but does not automatically
              entitle you to a refund for previously billed periods, except as
              provided under this Refund Policy or where required by applicable
              law.
            </li>
          </ul>

          <h2>7. Chargebacks</h2>
          <p>
            Customers agree to contact us first to attempt resolution before
            initiating a chargeback or payment dispute.
          </p>
          <p>
            Fraudulent or abusive chargebacks may result in the suspension or
            termination of Services, subject to applicable law.
          </p>

          <h2>8. Contact Information</h2>
          <div className="refund-page__contact">
            <p>Review Lumen</p>
            <p>David Osmukhin (sole proprietor)</p>
            <p>Rua General Justiniano Padrel 21</p>
            <p>1170-011 Lisbon</p>
            <p>Portugal</p>
            <p>
              Email:{' '}
              <a href="mailto:support@reviewlumen.com">support@reviewlumen.com</a>
            </p>
            <p>
              Phone: <a href="tel:+351932581722">+351 932 581 722</a>
            </p>
          </div>
        </div>
      </main>

      <FooterSection />
    </div>
  );
}
